import { Operator } from '../../../../shared/api/api';

export function fastExpLanguageConfiguration(): any {
  return {
    comments: {
      // Note "//" comments are supported by we are defaulting to using "#" for editor commands.
      lineComment: '#',
      blockComment: ['/*', '*/'],
    },
    brackets: [
      ['(', ')'],
      ['[', ']'],
      ['{', '}'],
    ],
  };
}

export function fastExpLanguageDefinition(expOperators: Operator[], expFields: string[]): any {
  const stringContent = '[0-9a-zA-Z_:./|,; \\[\\]]*';

  return {
    ignoreCase: true,
    defaultToken: 'invalid',
    tokenPostfix: '.wqfastexpression',

    brackets: [
      ['{', '}', 'delimiter.curly'],
      ['[', ']', 'delimiter.square'],
      ['(', ')', 'delimiter.parenthesis'],
    ],

    arithmeticoperators: ['+', '-', '*', '/', '^', '<', '<=', '>', '>=', '==', '!=', '||', '&&', '!', '?', ':', '=', '**'],

    operators: expOperators.map(operator => operator.name),

    keywords: expFields,

    digits: /\d+(_+\d+)*/,

    tokenizer: {
      root: [
        [/\/\*/, 'comment', '@comment'],
        ['#[^\n]*|//[^\n]*', 'comment'],
        [/\s+/, 'white'],

        [new RegExp("'" + stringContent + '\'?|"' + stringContent + '"?'), 'string'],

        [
          /[A-Za-z_][\w]*/,
          {
            cases: {
              '@operators': 'type',
              '@keywords': 'keyword',
              '@default': 'identifier',
            },
          },
        ],

        [/[(){}\[\]]/, '@brackets'],
        [
          /(\+|-|\*|\/|\^|\|\||&&|!|<=|>=|<|>|==|!=|=|\?|:)/,
          {
            cases: {
              '@arithmeticoperators': 'operator',
              '@default': 'invalid',
            },
          },
        ],

        [/(@digits)\.(@digits)?/, 'number.float'],
        [/(@digits)/, 'number'],

        [/[;,.]/, 'delimiter'],

        [/.*\..*\..*/, 'nesteddots'],

        [/"([^"\\]|\\.)*$/, 'string.invalid'],
        [/'([^'\\]|\\.)*$/, 'string.invalid'],
        [/"/, 'string', '@string_double'],
        [/'/, 'string', '@string_single'],
      ],

      comment: [
        [/[^\/*]+/, 'comment'],
        ['\\*/', 'comment', '@pop'],
        [/[\/*]/, 'comment'],
      ],
      string_double: [
        [/[^\\"]+/, 'string'],
        [/"/, 'string', '@pop'],
      ],
      string_single: [
        [/[^\\']+/, 'string'],
        [/'/, 'string', '@pop'],
      ],
    },
  };
}
